import React, { FC } from "react"

import { Button, Group, Modal, ModalProps, Stack, Text, Textarea, TextInput } from "@mantine/core"
import { IconPlus } from "@tabler/icons-react"

import useCreateGroup from "./useCreateGroup"
import { useLanguage } from "../../../contexts/language-context"

type CreateGroupModalProps = ModalProps

const CreateGroupModal: FC<CreateGroupModalProps> = ({ ...props }) => {
    const { form, onSubmit, processing } = useCreateGroup(props.onClose)
    const { L } = useLanguage()

    return (
        <Modal {...props} title={<Text weight="bold">{L("Create new group")}</Text>}>
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Stack>
                    <TextInput label={L("Group name")} placeholder={L("Name")} {...form.getInputProps("name")} />
                    <Textarea
                        label={`${L("Description")} (${L("optional")})`}
                        placeholder={L("Description")}
                        minRows={3}
                        {...form.getInputProps("description")}
                    />
                    <Group position="right" noWrap>
                        <Button variant="subtle" onClick={props.onClose}>
                            {L("Cancel")}
                        </Button>
                        <Button type="submit" variant="filled" leftIcon={<IconPlus size={16} />} loading={processing}>
                            {L("Create group")}
                        </Button>
                    </Group>
                </Stack>
            </form>
        </Modal>
    )
}

export default CreateGroupModal
